const SCROLLABLE_CLASS_NAME = '.validation-scroll-container';
const ITEM_CLASS_NAME = '.MuiGrid-item';

const FAVORITES_FOOTER_CLASS_NAME_BASKET = '.trustpilot-widget-wrapper';
const HEADER_CLASS_NAME_BASKET = '.fixed-header';
const FOOTER_CLASS_NAME_BASKET = '.footer-container';

const FAVORITES_HEADER_CLASS_NAME_CHECKOUT = '.basket-checkout-container__trustpilot-wrapper';
const HEADER_CLASS_NAME_CHECKOUT = '.basket-checkout-container__header-wrapper';
const FOOTER_CLASS_NAME_CHECKOUT = '.basket-checkout-container__footer-wrapper';

export class ScrollHelper {
    public scrollToPosition(position: number): void {
        window.scroll({ top: position, left: 0, behavior: 'smooth' });
    }

    public scrollToExcludeFooterHeader(component: any): void {
        const targetPosition = (component.current?.offsetTop ?? component.element?.current.offsetTop) ?? component.offsetTop;
        this.clampAndScroll(targetPosition);
    }

    public scrollToTopPage(): void {
        this.scrollToPosition(0);
    }

    public scrollTo(targetElement: React.RefObject<HTMLElement>, itemClassName?: string) {
        const targetInvalidField = targetElement.current;

        if (targetInvalidField) {
            let item: HTMLElement = this.getTargetElement(targetInvalidField, itemClassName) ?? this.getDefaultElement(targetInvalidField);

            let targetPosition = item.offsetTop;

            if (Math.abs(targetInvalidField.offsetTop - item.offsetTop) > (window.innerHeight - targetInvalidField.clientHeight)) {
                const itemContainerOffset = this.getTargetElement(targetInvalidField, itemClassName ?? ITEM_CLASS_NAME)?.offsetTop ?? 0;
                targetPosition = itemContainerOffset || targetInvalidField.offsetTop;
            }

            this.clampAndScroll(targetPosition);
        } else {
            this.scrollToExcludeFooterHeader(targetElement);
        }
    }

    public scrollToTopOfElement(targetElement: React.RefObject<HTMLElement>) {
        targetElement.current?.scrollIntoView();
    }

    private getTargetElement(element: HTMLElement, targetElementClassName?: string): HTMLElement | null {
        return targetElementClassName ? element.closest(targetElementClassName) : this.getDefaultElement(element);
    }

    private getDefaultElement(element: HTMLElement): HTMLElement {
        return element.closest(SCROLLABLE_CLASS_NAME) ?? element.closest(ITEM_CLASS_NAME) ?? element;
    }

    /* complete height of entirely loaded page, everything you can scroll */
    private getDocumentHeight(): number {
        const body = document.body,
            html = document.documentElement;

        return Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);
    }

    /* basket and checkout pages have different header/footer classnames.
        basket page has favourites widget clamped to footer,
        checkout pages have favorites clamped to header */
    private getHeaderHeight(): number {
        const favoritesHeader = document.querySelector(FAVORITES_HEADER_CLASS_NAME_CHECKOUT);
        const header = document.querySelector(HEADER_CLASS_NAME_CHECKOUT) ?? document.querySelector(HEADER_CLASS_NAME_BASKET);
        const headerSize = (favoritesHeader ? favoritesHeader.clientHeight : 0) + (header ? header.clientHeight : 0);

        return headerSize;
    }

    /* basket and checkout pages have different header/footer classnames.
        basket page has favourites widget clamped to footer,
        checkout pages have favorites clamped to header */
    private getFooterHeight(): number {
        const favoritesFooter = document.querySelector(FAVORITES_FOOTER_CLASS_NAME_BASKET);
        const footer = document.querySelector(FOOTER_CLASS_NAME_CHECKOUT) ?? document.querySelector(FOOTER_CLASS_NAME_BASKET);
        const footerSize = (favoritesFooter ? favoritesFooter.clientHeight : 0) + (footer ? footer.clientHeight : 0);

        return footerSize;
    }

    /* exclude header and footer from displaying when scrolling to a component */
    private clampAndScroll(targetPosition: number): void {
        const headerSize = this.getHeaderHeight();
        const footerSize = this.getFooterHeight();
        const documentHeight = this.getDocumentHeight();

        const minScrollPos = headerSize;
        const maxScrollPos = documentHeight - footerSize - window.innerHeight;

        this.scrollToPosition(this.clamp(targetPosition, minScrollPos, maxScrollPos));
    }

    /* to make a number not to fall below or be above limits */
    private clamp(value: number, min: number, max: number): number {
        const result = value <= min ? min : (value >= max ? max : value);

        return result > 0 ? result : 0;
    }
}

export const scrollHelper = new ScrollHelper();